import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function LoginButton() {
  const { login } = useKindeAuth();
  const { t } = useTranslation();

  return (
    <Button onClick={() => login()} aria-label={t('auth.loginAriaLabel')} className="touch-target">
      {t('auth.login')}
    </Button>
  );
}
